import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useCustomerAuth } from '@/contexts/CustomerAuthContext';
import { useFleetAuth } from '@/contexts/FleetAuthContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export function DriverProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner size="lg" />;
  if (!user) return <Navigate to="/driver/login" replace />;
  return <>{children}</>;
}

export function CustomerProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useCustomerAuth();
  if (loading) return <LoadingSpinner size="lg" />;
  if (!user) return <Navigate to="/customer/login" replace />;
  return <>{children}</>;
}

export function FleetProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useFleetAuth();
  if (loading) return <LoadingSpinner size="lg" />;
  if (!user) return <Navigate to="/fleet/login" replace />;
  return <>{children}</>;
}

export const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500" />
  </div>
);
